(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /**
     * Announcement bar: one message at a time with previous/next controls.
     * Auto-rotation is opt-in, has a visible pause button, pauses on hover and
     * focus, and is turned off for shoppers who prefer reduced motion.
     */
    class AnnouncementBar extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.announcement-bar__track');
        // Each message is a direct child of the track (its theme block wrapper).
        this.messages = this.track ? [...this.track.children] : [];
        if (this.messages.length < 2) return;

        this.abort = new AbortController();
        const { signal } = this.abort;
        this.index = 0;
        this.pauseButton = this.querySelector('[data-announcement-pause]');
        this.delay = Number(this.dataset.autoRotate) || 0;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoRotate = this.delay > 0 && !reducedMotion && !window.Shopify?.designMode;
        this.paused = false;

        this.querySelectorAll('[data-announcement-previous], [data-announcement-next]').forEach((button) => {
          button.hidden = false;
          const step = button.hasAttribute('data-announcement-next') ? 1 : -1;
          button.addEventListener('click', () => this.show(this.index + step, true), { signal });
        });

        if (this.autoRotate && this.pauseButton) {
          this.pauseButton.hidden = false;
          this.pauseButton.addEventListener('click', () => this.setPaused(!this.paused), { signal });
          this.addEventListener('pointerenter', () => this.stop(), { signal });
          this.addEventListener('pointerleave', () => this.start(), { signal });
          this.addEventListener('focusin', () => this.stop(), { signal });
          this.addEventListener(
            'focusout',
            (event) => {
              if (!this.contains(event.relatedTarget)) this.start();
            },
            { signal }
          );
        }

        document.addEventListener(
          'shopify:block:select',
          (event) => {
            const index = this.messages.findIndex((message) => message.contains(event.target) || message === event.target);
            if (index >= 0) this.show(index, true);
          },
          { signal }
        );

        this.setAttribute('data-ready', '');
        this.show(0, false);
        this.start();
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.stop();
      }

      show(index, manual) {
        this.index = (index + this.messages.length) % this.messages.length;
        this.messages.forEach((message, i) => {
          message.toggleAttribute('data-active', i === this.index);
          message.toggleAttribute('inert', i !== this.index);
        });
        if (manual) this.restart();
      }

      setPaused(paused) {
        this.paused = paused;
        this.pauseButton.setAttribute('aria-pressed', String(paused));
        if (paused) this.stop();
        else this.start();
      }

      start() {
        if (!this.autoRotate || this.paused || this.timer) return;
        this.track.setAttribute('aria-live', 'off');
        this.timer = setInterval(() => this.show(this.index + 1, false), this.delay);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
        this.track?.setAttribute('aria-live', 'polite');
      }

      restart() {
        this.stop();
        this.start();
      }
    }

    if (!customElements.get('announcement-bar')) customElements.define('announcement-bar', AnnouncementBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    if (customElements.get('cart-items')) return;

    class CartError extends Error {}

    /* Enhances the native cart form; every change is applied by Shopify and the
       section's markup is re-rendered from the server response. */
    class CartItems extends HTMLElement {
      connectedCallback() {
        this.queue = Promise.resolve();
        this.pending = 0;
        this.dataset.enhanced = '';
        this.querySelectorAll('[data-quantity-step]').forEach((button) => (button.hidden = false));

        this.addEventListener('click', (event) => this.onClick(event));
        this.addEventListener('input', (event) => {
          if (event.target.matches('[data-quantity-input]')) this.schedule(event.target, 600);
        });
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-quantity-input]')) this.schedule(event.target, 0);
          if (event.target.matches('[data-cart-note]')) this.saveNote(event.target.value);
        });
        this.addEventListener('submit', (event) => {
          if (!this.pending) return;
          event.preventDefault();
          const submitter = event.submitter;
          this.queue.then(() => this.querySelector('form')?.requestSubmit(submitter?.isConnected ? submitter : undefined));
        });
      }

      onClick(event) {
        const step = event.target.closest('[data-quantity-step]');
        if (step) {
          const input = step.closest('.bag__item').querySelector('[data-quantity-input]');
          const before = input.value;
          if (Number(step.dataset.quantityStep) > 0) input.stepUp();
          else input.stepDown();
          if (input.value !== before) this.schedule(input, 250);
          return;
        }
        const remove = event.target.closest('[data-cart-remove]');
        if (remove) {
          event.preventDefault();
          this.update(remove.closest('[data-line-key]'), 0);
        }
      }

      /* The line shows its loading state at once; the request waits for a pause. */
      schedule(input, delay) {
        const line = input.closest('[data-line-key]');
        clearTimeout(input.updateTimer);
        this.setBusy(line, true);
        input.updateTimer = setTimeout(() => this.update(line, input.value), delay);
      }

      update(line, value) {
        if (!line) return;
        const quantity = Math.max(0, Number.parseInt(value, 10) || 0);
        if (String(quantity) === line.dataset.quantity) {
          this.setBusy(line, false);
          if (!this.pending) this.querySelector('[data-cart-checkout]')?.removeAttribute('aria-disabled');
          return;
        }
        this.pending += 1;
        this.setBusy(line, true);
        this.queue = this.queue.then(() => this.request(line, quantity));
      }

      async request(line, quantity) {
        const key = line.dataset.lineKey;
        try {
          const response = await fetch(`${this.dataset.changeUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity, sections: this.dataset.sectionId, sections_url: window.location.pathname }),
          });
          const data = await response.json().catch(() => ({}));
          if (!response.ok) throw new CartError(data.description || data.message || '');
          const html = data.sections?.[this.dataset.sectionId];
          if (!html) {
            window.location.reload();
            return;
          }
          this.render(html, key);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart', cart: data } }));
        } catch (error) {
          this.showError(line, error instanceof CartError && error.message ? error.message : this.dataset.errorGeneric);
        } finally {
          this.pending -= 1;
          if (line.isConnected) this.setBusy(line, false);
          if (!this.pending) this.querySelector('[data-cart-checkout]')?.removeAttribute('aria-disabled');
        }
      }

      setBusy(line, busy) {
        if (busy) line.setAttribute('aria-busy', 'true');
        else line.removeAttribute('aria-busy');
        const totals = this.querySelector('[data-cart-region="totals"]');
        if (busy || this.pending > 0) totals?.setAttribute('aria-busy', 'true');
        else totals?.removeAttribute('aria-busy');
        if (busy) this.querySelector('[data-cart-checkout]')?.setAttribute('aria-disabled', 'true');
        if (busy) line.querySelector('[data-line-error]')?.setAttribute('hidden', '');
      }

      showError(line, message) {
        if (!line.isConnected) return;
        const input = line.querySelector('[data-quantity-input]');
        if (input) input.value = line.dataset.quantity;
        const error = line.querySelector('[data-line-error]');
        if (error) {
          error.textContent = message;
          error.hidden = false;
        }
      }

      /* Swap the regions that changed. The live region, the order note and the
         checkout button stay in place, so typed text and focus aren't lost. */
      render(html, changedKey) {
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items');
        if (!next) return;
        const active = document.activeElement;
        const focusLine = active?.closest?.('[data-line-key]');
        const focusKey = focusLine?.dataset.lineKey;
        const focusId = active?.dataset?.focusId;
        const lines = [...this.querySelectorAll('[data-line-key]')].map((el) => el.dataset.lineKey);
        /* Read before swapping: replaceWith() moves the fresh regions out of `next`. */
        const message = next.querySelector('[data-cart-region="totals"]')?.dataset.liveMessage
          ?? next.querySelector('.bag__empty-heading')?.textContent;

        if (!next.querySelector('form')) {
          this.querySelector('.bag__inner').replaceWith(next.querySelector('.bag__inner'));
          this.querySelector('h1')?.focus();
        } else {
          for (const region of this.querySelectorAll('[data-cart-region]')) {
            const fresh = next.querySelector(`[data-cart-region="${region.dataset.cartRegion}"]`);
            if (fresh) region.replaceWith(fresh);
          }
          this.querySelectorAll('[data-quantity-step]').forEach((button) => (button.hidden = false));
          this.restoreFocus(focusKey, focusId, changedKey, lines);
        }

        const live = this.querySelector('[data-cart-live]');
        if (live && message) {
          live.textContent = '';
          setTimeout(() => (live.textContent = message), 100);
        }
      }

      restoreFocus(focusKey, focusId, changedKey, previousLines) {
        if (focusKey && focusId) {
          const target = this.querySelector(`[data-line-key="${CSS.escape(focusKey)}"] [data-focus-id="${focusId}"]`);
          if (target && !target.disabled) {
            target.focus();
            return;
          }
        }
        if (!this.querySelector(`[data-line-key="${CSS.escape(changedKey)}"]`)) {
          const index = previousLines.indexOf(changedKey);
          const remaining = [...this.querySelectorAll('[data-line-key]')];
          const neighbour = remaining[Math.min(index, remaining.length - 1)];
          (neighbour?.querySelector('.bag__title a') ?? this.querySelector('h1'))?.focus();
        }
      }

      saveNote(note) {
        fetch(`${this.dataset.updateUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note }),
        }).catch(() => {
          /* The note is also sent with the form at checkout. */
        });
      }
    }

    customElements.define('cart-items', CartItems);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page"]) return;
  try {
    
  (() => {
    if (customElements.get('contact-form')) return;

    /* Progressive enhancement: native validation works without this. */
    class ContactForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.form.noValidate = true;
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
        this.form.addEventListener('input', (event) => {
          if (event.target.getAttribute('aria-invalid') === 'true') this.validate(event.target);
        });
        this.form.addEventListener('focusout', (event) => {
          if (event.target.matches('input, textarea') && event.target.value !== '') this.validate(event.target);
        });
        this.querySelector('[data-form-status]')?.focus();
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.reset();
        });
      }

      /* A page restored from the back/forward cache must not stay in the sending state. */
      reset() {
        this.submitting = false;
        const submit = this.form.querySelector('[data-submit]');
        if (!submit) return;
        submit.removeAttribute('aria-disabled');
        submit.textContent = submit.dataset.label;
      }

      /* Returns the message for the first failed rule, or '' when valid. Length
         and blank checks are explicit: browsers skip minlength on prefilled
         values and accept whitespace-only answers as filled. */
      messageFor(field) {
        const value = field.value.trim();
        if (field.required && value === '') return this.dataset.messageRequired;
        if (value === '') return '';
        if (field.validity.typeMismatch && field.type === 'email') return this.dataset.messageEmail;
        if (field.validity.patternMismatch && field.type === 'tel') return this.dataset.messagePhone;
        if (field.minLength > 0 && value.length < field.minLength) return this.dataset.messageShort;
        return field.checkValidity() ? '' : field.validationMessage;
      }

      validate(field) {
        const error = this.querySelector(`#${CSS.escape(field.id)}-error`);
        if (!error) return true;
        const message = this.messageFor(field);
        const valid = message === '';
        error.textContent = message;
        error.hidden = valid;
        if (valid) {
          field.removeAttribute('aria-invalid');
          field.removeAttribute('aria-describedby');
        } else {
          field.setAttribute('aria-invalid', 'true');
          field.setAttribute('aria-describedby', error.id);
        }
        return valid;
      }

      onSubmit(event) {
        if (this.submitting) {
          event.preventDefault();
          return;
        }
        const fields = [...this.form.querySelectorAll('input:not([type="hidden"]), textarea')];
        const invalid = fields.filter((field) => !this.validate(field));
        if (invalid.length) {
          event.preventDefault();
          invalid[0].focus();
          return;
        }
        const submit = this.form.querySelector('[data-submit]');
        if (submit) {
          submit.setAttribute('aria-disabled', 'true');
          submit.textContent = this.dataset.sending;
        }
        this.submitting = true;
      }
    }

    customElements.define('contact-form', ContactForm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Long footer menus are accordions on phones only; wider screens always show them open. */
    const wide = window.matchMedia('(min-width: 750px)');
    const sync = () => {
      document.querySelectorAll('[data-footer-accordion]').forEach((details) => {
        details.open = wide.matches;
      });
    };
    sync();
    wide.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const DESKTOP = '(min-width: 990px)';
    const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

    /**
     * Sticky header: publishes --header-height, shows a hairline once the
     * page scrolls, hides on scroll down and reveals on scroll up (when the
     * merchant chose "reveal"), and switches to the compact pattern whenever
     * the desktop menu would not fit on one line.
     */
    class StickyHeader extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.section = this.closest('.shopify-section') || this;
        this.header = this.querySelector('.header');
        this.nav = this.querySelector('.header__nav');
        this.lastY = window.scrollY;

        this.resizeObserver = new ResizeObserver(() => {
          this.checkFit();
          document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
        });
        this.resizeObserver.observe(this);
        document.fonts?.ready.then(() => this.checkFit());

        window.addEventListener('scroll', () => this.queueUpdate(), { passive: true, signal });
        this.update();
      }

      disconnectedCallback() {
        this.abort.abort();
        this.resizeObserver.disconnect();
        this.section.removeAttribute('data-header-hidden');
      }

      get reveals() {
        if (this.dataset.sticky !== 'reveal') return false;
        if (window.Shopify?.designMode) return false;
        return !window.matchMedia(REDUCED_MOTION).matches;
      }

      /** True while the shopper is working inside the header. */
      get isBusy() {
        return (
          this.contains(document.activeElement) ||
          this.querySelector('[aria-expanded="true"]') !== null ||
          this.querySelector('dialog[open]') !== null
        );
      }

      checkFit() {
        if (!this.nav || !this.header) return;
        if (!window.matchMedia(DESKTOP).matches) {
          this.header.classList.remove('header--compact');
          return;
        }
        this.header.classList.remove('header--compact');
        const list = this.nav.querySelector('.header-nav__list');
        if (list && list.scrollWidth > this.nav.clientWidth + 1) {
          this.header.classList.add('header--compact');
        }
      }

      queueUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const y = Math.max(window.scrollY, 0);
        this.toggleAttribute('data-scrolled', y > 0);

        if (!this.reveals) {
          this.section.removeAttribute('data-header-hidden');
          this.lastY = y;
          return;
        }

        if (y <= this.offsetHeight) {
          this.section.removeAttribute('data-header-hidden');
          this.lastY = y;
          return;
        }

        const delta = y - this.lastY;
        if (Math.abs(delta) < 8) return;
        this.lastY = y;

        if (delta > 0 && !this.isBusy) {
          this.section.setAttribute('data-header-hidden', '');
        } else if (delta < 0) {
          this.section.removeAttribute('data-header-hidden');
        }
      }
    }

    /**
     * Desktop menu disclosures: click, Enter or Space toggles; on hover-capable
     * pointers, hover opens after 150ms and closes after 300ms. Escape closes
     * and returns focus; an outside click or tabbing away closes.
     */
    class HeaderMenu extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.hover = window.matchMedia('(hover: hover) and (pointer: fine)');

        this.querySelectorAll('button[aria-expanded]').forEach((button) => {
          const item = button.closest('li');

          button.addEventListener(
            'click',
            () => {
              if (button.dataset.hoverOpened) {
                delete button.dataset.hoverOpened;
                return;
              }
              this.toggle(button, button.getAttribute('aria-expanded') !== 'true');
            },
            { signal }
          );

          item.addEventListener(
            'pointerenter',
            (event) => {
              if (event.pointerType !== 'mouse' || !this.hover.matches) return;
              clearTimeout(item.closeTimer);
              clearTimeout(item.openTimer);
              if (button.getAttribute('aria-expanded') === 'true') return;
              item.openTimer = setTimeout(() => {
                this.toggle(button, true);
                button.dataset.hoverOpened = 'true';
                setTimeout(() => delete button.dataset.hoverOpened, 400);
              }, 150);
            },
            { signal }
          );

          item.addEventListener(
            'pointerleave',
            (event) => {
              if (event.pointerType !== 'mouse' || !this.hover.matches) return;
              clearTimeout(item.openTimer);
              item.closeTimer = setTimeout(() => this.toggle(button, false), 300);
            },
            { signal }
          );

          item.addEventListener(
            'focusout',
            (event) => {
              if (event.relatedTarget && !item.contains(event.relatedTarget)) this.toggle(button, false);
            },
            { signal }
          );
        });

        this.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== 'Escape') return;
            const open = this.querySelector('button[aria-expanded="true"]');
            if (!open) return;
            event.preventDefault();
            this.toggle(open, false);
            open.focus();
          },
          { signal }
        );

        document.addEventListener(
          'click',
          (event) => {
            if (!this.contains(event.target)) this.closeAll();
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.abort.abort();
      }

      toggle(button, open) {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        if (open) this.closeAll(button);
        button.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
      }

      closeAll(except) {
        this.querySelectorAll('button[aria-expanded="true"]').forEach((button) => {
          if (button !== except) this.toggle(button, false);
        });
      }
    }

    /** Mobile menu drawer, built on a native modal dialog. */
    class MenuDrawer extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-drawer-open]');

        this.opener.addEventListener('click', () => this.open(), { signal });
        this.querySelector('[data-drawer-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('click', (event) => closeOnBackdrop(event, this.dialog), { signal });
        this.dialog.addEventListener(
          'close',
          () => {
            this.opener.setAttribute('aria-expanded', 'false');
            this.opener.focus({ preventScroll: true });
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.abort.abort();
        if (this.dialog?.open) this.dialog.close();
      }

      open() {
        this.dialog.showModal();
        this.opener.setAttribute('aria-expanded', 'true');
      }
    }

    /**
     * Search dialog with predictive results (ARIA combobox + listbox).
     * If the Predictive Search API rejects the shopper's language (it answers
     * 417 for unsupported locales), predictive search is switched off for that
     * language for the rest of the session; the form still submits to /search.
     */
    class SearchDialog extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-search-open]');
        this.input = this.querySelector('input[type="search"]');
        this.results = this.querySelector('[data-search-results]');
        this.status = this.querySelector('[data-search-status]');
        this.offKey = `honey-lab:predictive-off:${this.dataset.locale}`;

        this.opener.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            this.dialog.showModal();
            this.opener.setAttribute('aria-expanded', 'true');
            this.input.focus();
            this.input.select();
          },
          { signal }
        );
        this.querySelector('[data-search-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('click', (event) => closeOnBackdrop(event, this.dialog), { signal });
        this.dialog.addEventListener(
          'close',
          () => {
            this.opener.setAttribute('aria-expanded', 'false');
            this.opener.focus({ preventScroll: true });
          },
          { signal }
        );
        this.input.addEventListener('input', () => this.onInput(), { signal });
        this.input.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
      }

      disconnectedCallback() {
        this.abort.abort();
        this.request?.abort();
        if (this.dialog?.open) this.dialog.close();
      }

      get predictiveOff() {
        try {
          return sessionStorage.getItem(this.offKey) === '1';
        } catch {
          return false;
        }
      }

      set predictiveOff(value) {
        try {
          sessionStorage.setItem(this.offKey, value ? '1' : '0');
        } catch {
          /* Storage can be unavailable (private mode); the session flag is only an optimization. */
        }
        this.unsupported = value;
      }

      onInput() {
        clearTimeout(this.debounce);
        const terms = this.input.value.trim();
        if (terms.length < 2 || this.unsupported || this.predictiveOff) {
          this.request?.abort();
          this.clear();
          if (terms.length > 0 && (this.unsupported || this.predictiveOff)) this.showSearchFor(terms);
          return;
        }
        this.debounce = setTimeout(() => this.fetchResults(terms), 300);
      }

      async fetchResults(terms) {
        this.request?.abort();
        this.request = new AbortController();
        this.results.setAttribute('aria-busy', 'true');

        const params = new URLSearchParams({
          q: terms,
          'resources[type]': 'product,collection,query',
          'resources[limit]': '4',
          'resources[limit_scope]': 'each',
          section_id: 'predictive-search',
        });

        try {
          const response = await fetch(`${this.dataset.predictiveUrl}?${params}`, { signal: this.request.signal });
          if (!response.ok) {
            // 4xx (417 "Unsupported buyer locale") won't change this session;
            // a 5xx might, so only the former switches predictive search off.
            if (response.status >= 400 && response.status < 500) this.predictiveOff = true;
            this.clear();
            this.showSearchFor(terms);
            return;
          }
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const markup = html.querySelector('.predictive-search');
          if (!markup || this.input.value.trim() !== terms) return;

          this.results.replaceChildren(markup);
          this.activeIndex = -1;
          this.input.setAttribute('aria-expanded', 'true');
          this.input.removeAttribute('aria-activedescendant');
          this.dialog.toggleAttribute('data-has-results', Number(markup.dataset.resultCount) > 0);
          this.status.textContent = markup.dataset.status || '';
        } catch (error) {
          if (error.name !== 'AbortError') this.clear();
        } finally {
          this.results.removeAttribute('aria-busy');
        }
      }

      /** Fallback when there are no suggestions: one option that runs the full search. */
      showSearchFor(terms) {
        const url = new URL(this.querySelector('form').action, window.location.origin);
        url.searchParams.set('q', terms);
        url.searchParams.set('options[prefix]', 'last');

        const link = document.createElement('a');
        link.id = `${this.dialog.id}-search-for`;
        link.className = 'predictive-search__row predictive-search__row--all';
        link.href = url.toString();
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        const label = document.createElement('span');
        label.textContent = (this.dataset.searchFor || '').replace('__TERMS__', terms);
        link.append(label, this.querySelector('.search-dialog__submit .svg-icon').cloneNode(true));

        const item = document.createElement('li');
        item.setAttribute('role', 'presentation');
        item.append(link);
        const list = document.createElement('ul');
        list.className = 'predictive-search__list';
        list.setAttribute('role', 'listbox');
        list.append(item);
        this.results.replaceChildren(list);
        this.input.setAttribute('aria-expanded', 'true');
        this.activeIndex = -1;
      }

      clear() {
        this.results.replaceChildren();
        this.dialog.removeAttribute('data-has-results');
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        this.status.textContent = '';
        this.activeIndex = -1;
      }

      onKeydown(event) {
        const options = [...this.results.querySelectorAll('[role="option"]')];

        if (event.key === 'Escape' && options.length > 0) {
          event.preventDefault();
          this.clear();
          return;
        }

        if (options.length === 0) return;

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const step = event.key === 'ArrowDown' ? 1 : -1;
          this.activeIndex = (this.activeIndex + step + options.length) % options.length;
          options.forEach((option, index) => option.setAttribute('aria-selected', String(index === this.activeIndex)));
          const active = options[this.activeIndex];
          this.input.setAttribute('aria-activedescendant', active.id);
          active.scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter' && this.activeIndex >= 0) {
          event.preventDefault();
          window.location.assign(options[this.activeIndex].href);
        }
      }
    }

    /**
     * Live cart count. Listens for the `cart:updated` event that product
     * forms dispatch, and re-syncs when the page is restored from the
     * back/forward cache or the tab becomes visible again. The markup comes
     * from the Section Rendering API so translations stay on the server.
     */
    class CartCount extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.live = this.closest('.header')?.querySelector('[data-cart-live]');

        document.addEventListener('cart:updated', () => this.refresh(), { signal });
        window.addEventListener(
          'pageshow',
          (event) => {
            if (event.persisted) this.refresh();
          },
          { signal }
        );
        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.visibilityState === 'visible') this.refresh();
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.abort.abort();
      }

      async refresh() {
        const id = this.dataset.sectionId;
        try {
          const response = await fetch(`${this.dataset.rootUrl.replace(/\/$/, '')}/?sections=${id}`);
          if (!response.ok) return;
          const sections = await response.json();
          const html = new DOMParser().parseFromString(sections[id], 'text/html');
          const next = html.querySelector('cart-count');
          if (!next || next.innerHTML.trim() === this.innerHTML.trim()) return;
          this.innerHTML = next.innerHTML;
          if (this.live) this.live.textContent = this.querySelector('.visually-hidden')?.textContent ?? '';
        } catch {
          /* Offline or interrupted: keep the current count. */
        }
      }
    }

    function closeOnBackdrop(event, dialog) {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      const inside =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;
      if (!inside) dialog.close();
    }

    const define = (name, element) => {
      if (!customElements.get(name)) customElements.define(name, element);
    };
    define('sticky-header', StickyHeader);
    define('header-menu', HeaderMenu);
    define('menu-drawer', MenuDrawer);
    define('search-dialog', SearchDialog);
    define('cart-count', CartCount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-details')) {
    class ProductDetails extends HTMLElement {
      connectedCallback() {
        this.listeners?.abort();
        this.listeners = new AbortController();
        const { signal } = this.listeners;
        this.status = this.querySelector('[data-product-status]');
        this.error = this.querySelector('[data-product-error]');
        this.viewCart = this.querySelector('[data-view-cart]');
        this.adding = false;
        this.updating = false;
        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.addEventListener('submit', (event) => this.addToCart(event), { signal });
        this.addEventListener('change', (event) => {
          if (event.target.matches('[name="quantity"]')) this.syncQuantity();
          if (event.target.matches('[data-selling-plan]')) {
            const url = new URL(window.location.href);
            if (event.target.value) url.searchParams.set('selling_plan', event.target.value);
            else url.searchParams.delete('selling_plan');
            this.updateSelection(url, event.target.id);
          }
        }, { signal });
        this.addEventListener('input', (event) => {
          if (event.target.matches('[name="quantity"]')) this.syncQuantity();
        }, { signal });
        this.dataset.enhanced = '';
        this.enhanceControls();
      }

      disconnectedCallback() {
        this.listeners?.abort();
        this.selectionRequest?.abort();
        // Do not retry or abort cart mutations: a disconnected view may still have added an item.
      }

      enhanceControls() {
        this.querySelectorAll('[data-quantity-step]').forEach((node) => { node.hidden = false; });
        this.syncQuantity();
      }

      syncQuantity() {
        const input = this.querySelector('[name="quantity"]');
        if (!input) return;
        const value = input.valueAsNumber;
        const min = Number(input.min) || 1;
        const max = input.max ? Number(input.max) : Infinity;
        this.querySelectorAll('[data-quantity-step]').forEach((button) => {
          button.disabled = input.disabled || this.adding || this.updating ||
            (Number(button.dataset.quantityStep) < 0 ? value <= min : value >= max);
        });
      }

      onClick(event) {
        const quantity = event.target.closest('[data-quantity-step]');
        if (quantity && !quantity.disabled) {
          const input = this.querySelector('[name="quantity"]');
          if (Number(quantity.dataset.quantityStep) > 0) input.stepUp();
          else input.stepDown();
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        const option = event.target.closest('[data-option-link]');
        if (!option || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (this.adding) { event.preventDefault(); return; }
        const url = new URL(option.href);
        // Combined listings navigate natively so title, media and app blocks all change together.
        if (url.pathname !== new URL(this.dataset.productUrl, location.origin).pathname) return;
        event.preventDefault();
        const plan = this.querySelector('[data-selling-plan]')?.value;
        if (plan) url.searchParams.set('selling_plan', plan);
        this.updateSelection(url, null, option.dataset.optionId);
      }

      async updateSelection(url, focusId, optionId) {
        if (this.adding) return;
        this.selectionRequest?.abort();
        const controller = new AbortController();
        this.selectionRequest = controller;
        this.updating = true;
        this.status.textContent = this.dataset.loading;
        this.error.textContent = '';
        this.viewCart.hidden = true;
        const info = this.querySelector('[data-product-info]');
        info.setAttribute('aria-busy', 'true');
        const submit = info.querySelector('[data-add-to-cart]');
        if (submit) submit.disabled = true;
        this.syncQuantity();
        const requestUrl = new URL(url);
        requestUrl.searchParams.set('section_id', this.dataset.sectionId);
        try {
          const response = await fetch(requestUrl, { signal: controller.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Variant response failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = html.querySelector('[data-product-info]');
          if (!next) throw new Error('Missing product section');
          if (controller.signal.aborted || !this.isConnected) return;
          const previousQuantity = info.querySelector('[name="quantity"]')?.valueAsNumber;
          const accordionStates = new Map([...info.querySelectorAll('[data-accordion]')].map((node) => [node.dataset.accordion, node.open]));
          // Only replace variant-dependent blocks; preserve app and editorial block instances.
          for (const key of ['price', 'purchase']) {
            const currentBlock = info.querySelector(`[data-product-block="${key}"]`);
            const nextBlock = next.querySelector(`[data-product-block="${key}"]`);
            if (currentBlock && nextBlock) currentBlock.replaceWith(nextBlock);
          }
          info.dataset.selectedImage = next.dataset.selectedImage;
          info.dataset.variantId = next.dataset.variantId;
          const input = info.querySelector('[name="quantity"]');
          if (input && Number.isFinite(previousQuantity)) {
            const min = Number(input.min) || 1;
            const step = Number(input.step) || 1;
            const max = input.max ? Number(input.max) : Infinity;
            const aligned = min + Math.max(0, Math.floor((previousQuantity - min) / step)) * step;
            input.value = Math.min(aligned, min + Math.floor((max - min) / step) * step);
          }
          info.querySelectorAll('[data-accordion]').forEach((node) => {
            if (accordionStates.has(node.dataset.accordion)) node.open = accordionStates.get(node.dataset.accordion);
          });
          // Choosing a variant is a manual selection: show its image and stop gallery autoplay.
          this.querySelector('product-gallery')?.select?.(next.dataset.selectedImage, { manual: true });
          const publicUrl = new URL(url);
          publicUrl.searchParams.delete('section_id');
          if (next.dataset.variantId) {
            publicUrl.searchParams.delete('option_values');
            publicUrl.searchParams.set('variant', next.dataset.variantId);
          }
          history.replaceState(history.state, '', publicUrl);
          this.status.textContent = [info.querySelector('[data-price]')?.textContent, info.querySelector('[data-availability]')?.textContent].filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
          const focus = focusId ? info.querySelector(`#${CSS.escape(focusId)}`) : info.querySelector(`[data-option-id="${CSS.escape(optionId || '')}"]`);
          focus?.focus({ preventScroll: true });
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.status.textContent = '';
          this.error.textContent = this.dataset.variantError;
          // Keep purchase disabled until a successful selection fetch; never buy stale options.
          this.selectionFailed = true;
        } finally {
          if (this.selectionRequest === controller) {
            this.updating = false;
            info.removeAttribute('aria-busy');
            this.enhanceControls();
          }
        }
      }

      async addToCart(event) {
        if (!event.target.matches('.pdp-form')) return;
        event.preventDefault();
        const form = event.target;
        const submit = form.querySelector('[data-add-to-cart]');
        const variant = form.querySelector('[name="id"]');
        if (this.adding || this.updating || submit.disabled || !variant?.value || variant.disabled || !form.reportValidity()) return;
        const data = new FormData(form);
        const label = submit.querySelector('[data-submit-label]');
        const originalLabel = label.textContent;
        this.adding = true;
        submit.disabled = true;
        form.setAttribute('aria-busy', 'true');
        form.querySelectorAll('input:not([type="hidden"]), select').forEach((input) => { input.disabled = true; });
        label.textContent = this.dataset.adding;
        this.status.textContent = this.dataset.adding;
        this.error.textContent = '';
        this.viewCart.hidden = true;
        this.syncQuantity();
        // Ask Shopify for fresh header markup in the same mutation response.
        const counters = [...document.querySelectorAll('cart-count[data-section-id]')];
        const sectionIds = [...new Set(counters.map((counter) => counter.dataset.sectionId))].slice(0, 5);
        if (sectionIds.length) {
          data.set('sections', sectionIds.join(','));
          data.set('sections_url', window.location.pathname);
        }
        try {
          const response = await fetch(this.dataset.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
          const result = await response.json();
          if (!response.ok || result.status) {
            this.error.textContent = typeof result.description === 'string' ? result.description : this.dataset.error;
            this.status.textContent = '';
            this.viewCart.hidden = false;
            document.dispatchEvent(new CustomEvent('cart:updated'));
            return;
          }
          for (const counter of counters) {
            const markup = result.sections?.[counter.dataset.sectionId];
            if (!markup) continue;
            const fresh = new DOMParser().parseFromString(markup, 'text/html').querySelector('cart-count');
            if (fresh) counter.innerHTML = fresh.innerHTML;
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product', item: result } }));
          this.status.textContent = this.dataset.added;
          this.viewCart.hidden = false;
        } catch {
          // The server may have accepted a request whose response was lost. Never auto-retry.
          this.status.textContent = '';
          this.error.textContent = this.dataset.error;
          this.viewCart.hidden = false;
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } finally {
          this.adding = false;
          form.removeAttribute('aria-busy');
          form.querySelectorAll('input:not([type="hidden"]), select').forEach((input) => { input.disabled = false; });
          const currentVariantInput = form.querySelector('[name="id"]');
          submit.disabled = !currentVariantInput?.value || currentVariantInput.disabled;
          label.textContent = originalLabel;
          this.syncQuantity();
        }
      }
    }
    customElements.define('product-details', ProductDetails);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /**
     * Testimonials carousel: native scroll-snap does the swiping; the arrows move
     * by one card and disable at either end. No automatic sliding.
     */
    class TestimonialsCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-carousel-viewport]');
        this.controls = this.querySelector('[data-carousel-controls]');
        this.buttons = [...this.querySelectorAll('[data-carousel-step]')];
        if (!this.viewport || !this.controls) return;
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.step(Number(button.dataset.carouselStep)), { signal });
        });
        this.viewport.addEventListener('scroll', () => this.queueUpdate(), { signal, passive: true });
        this.resizeObserver = new ResizeObserver(() => this.queueUpdate());
        this.resizeObserver.observe(this.viewport);
        document.addEventListener(
          'shopify:block:select',
          (event) => {
            const item = event.target.closest?.('.testimonials__item');
            if (item && this.contains(item)) this.scrollToItem(item, false);
          },
          { signal }
        );
        this.update();
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      get isRtl() {
        return getComputedStyle(this.viewport).direction === 'rtl';
      }

      get behavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      /** Moves by one card toward the inline end (1) or start (-1), in either reading direction. */
      step(direction) {
        const item = this.viewport.querySelector('.testimonials__item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(item.parentElement).columnGap) || 0;
        const distance = (item.getBoundingClientRect().width + gap) * direction;
        this.viewport.scrollBy({ left: this.isRtl ? -distance : distance, behavior: this.behavior });
      }

      scrollToItem(item, smooth = true) {
        const box = this.viewport.getBoundingClientRect();
        const itemBox = item.getBoundingClientRect();
        const offset = this.isRtl ? itemBox.right - box.right : itemBox.left - box.left;
        this.viewport.scrollBy({ left: offset, behavior: smooth ? this.behavior : 'auto' });
      }

      queueUpdate() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        const max = this.viewport.scrollWidth - this.viewport.clientWidth;
        // RTL scrollLeft runs from 0 to -max, so compare distances from the start.
        const position = Math.abs(this.viewport.scrollLeft);
        this.controls.hidden = max <= 1;
        this.buttons.forEach((button) => {
          button.disabled = Number(button.dataset.carouselStep) < 0 ? position <= 1 : position >= max - 1;
        });
      }
    }

    if (!customElements.get('testimonials-carousel')) customElements.define('testimonials-carousel', TestimonialsCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
